import { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { customToastify } from "../../pages/utils/utilsFunctions";
import { Button, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import Typography from "@mui/material/Typography";
import DraggableComponent from "../DraggableComponent";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ButtonGroup from "@mui/material/ButtonGroup";
import TonalityIcon from "@mui/icons-material/Tonality";
import ModalAlert from "../Translations/ModalAlert";

export default function ShadowingButton(props) {
  const {
    semiAutoShadowing,
    handleSemiAutoShadowing,
    videoRef,
    handleFullScreen,
    userTypes,
    handleShowAllSubtitlesInShadowing,
  } = props;
  const [showModalAlert, setShowModalAlert] = useState(false);
  const handleOpenModalAlert = (action) => {
    if (action == "closeAll") {
      if (semiAutoShadowing["shortCut"])
        handleSemiAutoShadowing("shortCut", false);
    }
    setShowModalAlert(!showModalAlert);
  };
  const getVideoTime = (SECONDS) => {
    let res =
      SECONDS >= 3600
        ? new Date(SECONDS * 1000).toISOString().substring(12, 19)
        : new Date(SECONDS * 1000).toISOString().substring(14, 19);
    return res;
  };

  const handleOnbtn = () => {
    if (userTypes.length == 0) {
      handleSemiAutoShadowing(
        "errData",
        "برای استفاده از تکنیک سایه لطفا ابتدا لاگین کنید"
      );
    } else if (
      userTypes.includes("userPremium") ||
      userTypes.includes("admin") ||
      userTypes.includes("freetrial_all")
    ) {
      handleSemiAutoShadowing("on", true);
      if (semiAutoShadowing["showSubsContents"]) {
        handleShowAllSubtitlesInShadowing();
      }
    } else {
      handleOpenModalAlert();
    }
  };
  return (
    <Box
      sx={{
        // width: "150px",
        display: "block",
        position: "absolute",
        top: "50px",
        right: "150px",
      }}
    >
      <DraggableComponent maxWidth={"100%"}>
        <Divider
          onClick={() => {
            handleSemiAutoShadowing("showSettings");
          }}
          sx={{ textAlign: "center" }}
        >
          <Button endIcon={<TonalityIcon />}>تکنیک سایه</Button>
        </Divider>
        <ButtonGroup
          size="small"
          variant="contained"
          aria-label="Basic button group"
        >
          <Button
            onClick={() => {
              handleSemiAutoShadowing(
                "endTime",
                videoRef.current.getCurrentTime()
              );
            }}
          >
            <Typography style={{ fontSize: "12px" }}>
              <strong>End</strong> <br />{" "}
              {getVideoTime(semiAutoShadowing["endTime"])}
            </Typography>
          </Button>
          <Button
            onClick={() => {
              handleSemiAutoShadowing(
                "startTime",
                videoRef.current.getCurrentTime()
              );
            }}
          >
            <Typography style={{ fontSize: "12px" }}>
              <strong>start</strong> <br />{" "}
              {getVideoTime(semiAutoShadowing["startTime"])}
            </Typography>
          </Button>
          {semiAutoShadowing["on"] ? (
            <Button
              color={"success"}
              onClick={() => {
                handleSemiAutoShadowing("on", false);
              }}
            >
              <Typography style={{ fontSize: "12px" }}>
                <strong>on</strong> <br />{" "}
                {semiAutoShadowing["repeat"] -
                  semiAutoShadowing["currentRepeatIndex"]}
              </Typography>
            </Button>
          ) : (
            <Button
              color={"error"}
              onClick={() => {
                handleOnbtn();
              }}
            >
              off
            </Button>
          )}
        </ButtonGroup>
        {semiAutoShadowing["errData"] !== "" ? (
          <Typography
            style={{ backgroundColor: "red", color: "white", fontSize: "11px" }}
          >
            {semiAutoShadowing["errData"]}
          </Typography>
        ) : null}
      </DraggableComponent>
      {showModalAlert ? (
        <Box sx={{ marginTop: "25px" }}>
          <ModalAlert
            handleFullScreen={handleFullScreen}
            handleOpenModalAlert={handleOpenModalAlert}
          />
        </Box>
      ) : null}
    </Box>
  );
}
